// extracted by mini-css-extract-plugin
export const rootContainer = "layout-module--root-container--2A61R";
export const container = "layout-module--container--3nGj0";
export const content = "layout-module--content--bviAP";